import { Select as MuiSelect } from '@mui/material';
import { SelectProps } from './Select.props';

export const Select = <T = unknown,>({
  children,
  ...props
}: SelectProps<T>) => {
  return <MuiSelect<T> {...props}>{children}</MuiSelect>;
};

export default Select;
